import { render, staticRenderFns } from "./Carrinho.vue?vue&type=template&id=e2a21f16&scoped=true&"
import script from "./Carrinho.vue?vue&type=script&lang=js&"
export * from "./Carrinho.vue?vue&type=script&lang=js&"
import style0 from "./Carrinho.vue?vue&type=style&index=0&id=e2a21f16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a21f16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
